// Foreground polling interval in ms for the live club PoolShare total.
export const POOLA_POLL_MS = 60_000;

// ─── Poola buy surface (deals + offers + claim) ──────────────────────────────
// The member buy screen switches on these ints. They MIRROR the backend enums
// (the locked contract, poola-pwa-fe-contract-2026-06-30.md Section 6) — the source of
// truth is the PHP. Re-check against, do not silently diverge from:
//   ../backend/app/Enums/Commerce/PoolaDealStatus.php
//   ../backend/app/Enums/Commerce/PoolaOfferStatus.php
// The member surface only ever sees deal status ∈ {SCHEDULED, ACTIVE, ENDED}
// and offer status ∈ {ACTIVE, SOLD_OUT}; DRAFT/CANCELLED/DISABLED never reach
// the PWA.
export const POOLA_DEAL_STATUS = {
  DRAFT: 1,
  SCHEDULED: 2,
  ACTIVE: 3,
  ENDED: 4,
  CANCELLED: 5,
};

export const POOLA_OFFER_STATUS = {
  ACTIVE: 1,
  SOLD_OUT: 2,
  DISABLED: 3,
};

// Cursor page size for GET /poola-offers (server clamps 1–100, default 20).
export const POOLA_OFFERS_PAGE_LIMIT = 100;

// The countdown-week «عروض البولة بتكبر» card's goal: the توفير the offers should
// reach before the run opens (owner's goal for the November 2026 run, 1 Nov 2026).
// Cents. A later run sets its own number; 0 hides the card. One number here beats
// a column + admin field nobody else reads yet.
export const POOLA_GROWING_GOAL_CENTS = 100_000_00;

// Sentinel key for the "all suppliers" facet chip — a value that can never
// collide with a real supplier display name (the v1 client-side group key).
export const POOLA_SUPPLIER_ALL_KEY = '__all__';

// "Near-complete" claimed-ratio threshold for the completion-urgency copy/skin
// (poola-completion-poolcredit-prompts-copyable-2026-07-13.md Locked decisions).
// An offer is near-complete once piecesClaimed / piecesTotal crosses this, OR
// the existing low-stock floor is hit — see PoolaOffer.isNearComplete.
export const POOLA_NEAR_COMPLETE_RATIO = 0.8;
